import {getAll} from "app/requests/preview/episodes";
import * as Pages from "components/pages";

export default function PreviewTranscripts() {
  return <Pages.Public.Transcripts getEpisodes={getAll} prefix="/preview" />;
}
